import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[formatoDni]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormatoDniDirective),
      multi: true
    }
  ]
})
export class FormatoDniDirective implements ControlValueAccessor {
  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    if (value) {
      // Si llega un valor desde la API, lo convertimos a string y lo formateamos
      const stringValue = value.toString();
      this.formatAndSetValues(stringValue, false);
    } else {
      this.el.nativeElement.value = '';
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.el.nativeElement.disabled = isDisabled; }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.formatAndSetValues(value, true);
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  private formatAndSetValues(value: string, emitChangeToModel: boolean) {
    // 1. Limpiar el valor: dejamos estrictamente solo números
    let valorLimpio = value.replace(/\D/g, '');

    // 2. Limitar a un máximo de 8 dígitos
    if (valorLimpio.length > 8) {
      valorLimpio = valorLimpio.substring(0, 8);
    }

    // 3. Formatear la vista: agregar el punto cada miles
    // Esta expresión regular inserta un punto cada 3 dígitos contando desde el final
    let viewValue = valorLimpio.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // 4. Actualizar el input en el HTML con los puntos
    this.el.nativeElement.value = viewValue;

    // 5. Enviar el valor limpio al FormGroup (sin puntos)
    if (emitChangeToModel) {
      // Lo enviamos como string para evitar que se pierdan ceros a la izquierda 
      // (ej: si un DNI empieza con 0). Si tu backend exige estrictamente un number, 
      // podés cambiar esto a: parseInt(valorLimpio, 10)
      this.onChange(valorLimpio ? valorLimpio : null);
    }
  }
}